<template>
  <el-card>
    <div style="margin-bottom:16px;">
      <el-button type="primary" @click="openCreate">新增模板</el-button>
      <el-select v-model="filterProjectId" placeholder="筛选项目" clearable style="margin-left:10px;width:200px;" @change="loadData">
        <el-option label="通用模板" value="" />
        <el-option v-for="p in projects" :key="p.projectId" :label="p.name" :value="p.projectId" />
      </el-select>
    </div>
    <el-table :data="rows" border>
      <el-table-column prop="id" label="ID" width="80" />
      <el-table-column prop="name" label="模板名称" />
      <el-table-column label="关联项目" width="150">
        <template slot-scope="scope">
          {{ scope.row.projectId ? getProjectName(scope.row.projectId) : '通用模板' }}
        </template>
      </el-table-column>
      <el-table-column label="画布尺寸" width="120">
        <template slot-scope="scope">{{ scope.row.canvasWidth }}×{{ scope.row.canvasHeight }}</template>
      </el-table-column>
      <el-table-column label="默认" width="80">
        <template slot-scope="scope">
          <el-tag v-if="scope.row.isDefault" type="success" size="mini">是</el-tag>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column label="状态" width="80">
        <template slot-scope="scope">
          <el-tag :type="scope.row.status ? 'success' : 'info'" size="mini">
            {{ scope.row.status ? '启用' : '禁用' }}
          </el-tag>
        </template>
      </el-table-column>
      <el-table-column label="操作" width="280">
        <template slot-scope="scope">
          <el-button size="mini" @click="goEdit(scope.row)">编辑模板</el-button>
          <el-button v-if="!scope.row.isDefault" size="mini" type="success" @click="setDefault(scope.row)">设为默认</el-button>
          <el-button size="mini" :type="scope.row.status ? 'warning' : 'success'" @click="toggleStatus(scope.row)">
            {{ scope.row.status ? '禁用' : '启用' }}
          </el-button>
          <el-button size="mini" type="danger" @click="remove(scope.row)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <el-dialog :visible.sync="createVisible" title="新增模板" width="500px">
      <el-form :model="createForm" label-width="100px" size="small">
        <el-form-item label="模板名称">
          <el-input v-model="createForm.name" placeholder="请输入模板名称" />
        </el-form-item>
        <el-form-item label="关联项目">
          <el-select v-model="createForm.projectId" placeholder="选择项目（留空为通用模板）" clearable style="width:100%;">
            <el-option v-for="p in projects" :key="p.projectId" :label="p.name" :value="p.projectId" />
          </el-select>
        </el-form-item>
        <el-form-item label="画布宽度">
          <el-input-number v-model="createForm.canvasWidth" :min="100" :max="1000" />
        </el-form-item>
        <el-form-item label="画布高度">
          <el-input-number v-model="createForm.canvasHeight" :min="100" :max="2000" />
        </el-form-item>
      </el-form>
      <span slot="footer">
        <el-button @click="createVisible=false">取消</el-button>
        <el-button type="primary" @click="submitCreate">确定</el-button>
      </span>
    </el-dialog>
  </el-card>
</template>

<script>
import {
  getPosterTemplateList,
  createPosterTemplate,
  deletePosterTemplate,
  updatePosterTemplateStatus,
  setPosterTemplateDefault,
  getProjectList
} from '@/api'

export default {
  data() {
    return {
      rows: [],
      projects: [],
      filterProjectId: null,
      createVisible: false,
      createForm: {
        name: '',
        projectId: null,
        canvasWidth: 941,
        canvasHeight: 1672
      }
    }
  },
  created() {
    this.loadProjects()
    this.loadData()
  },
  methods: {
    async loadProjects() {
      const res = await getProjectList()
      this.projects = res.data || []
    },
    async loadData() {
      const params = {}
      if (this.filterProjectId !== null) {
        params.projectId = this.filterProjectId
      }
      const res = await getPosterTemplateList(params)
      this.rows = res.data || []
    },
    getProjectName(projectId) {
      const project = this.projects.find(p => p.projectId === projectId)
      return project ? project.name : projectId
    },
    openCreate() {
      this.createForm = {
        name: '',
        projectId: null,
        canvasWidth: 941,
        canvasHeight: 1672
      }
      this.createVisible = true
    },
    async submitCreate() {
      try {
        const res = await createPosterTemplate({
          ...this.createForm,
          status: 1,
          isDefault: 0,
          sortOrder: 0,
          templateUrl: '',
          qrUrl: '',
          layoutConfig: JSON.stringify(this.getDefaultLayoutConfig())
        })
        this.$message.success('创建成功')
        this.createVisible = false
        this.loadData()
        if (res.data && res.data.id) {
          this.goEdit({ id: res.data.id })
        }
      } catch (error) {
        this.$message.error(error.message || '创建失败')
      }
    },
    goEdit(row) {
      this.$router.push({
        path: `/poster-templates/${row.id}`
      })
    },
    async remove(row) {
      try {
        await this.$confirm('确认删除该模板？', '提示', { type: 'warning' })
        await deletePosterTemplate(row.id)
        this.$message.success('已删除')
        this.loadData()
      } catch (error) {
        if (error !== 'cancel') {
          this.$message.error(error.message || '删除失败')
        }
      }
    },
    async toggleStatus(row) {
      try {
        const newStatus = row.status ? 0 : 1
        await updatePosterTemplateStatus(row.id, newStatus)
        this.$message.success(newStatus ? '已启用' : '已禁用')
        this.loadData()
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    async setDefault(row) {
      try {
        await setPosterTemplateDefault(row.id)
        this.$message.success('已设为默认模板')
        this.loadData()
      } catch (error) {
        this.$message.error(error.message || '操作失败')
      }
    },
    getDefaultLayoutConfig() {
      return {
        speciesName: { 
          visible: true, x: 75, y: 120, w: 791, h: 100, 
          bg: '#FFFFFF', borderRadius: 20, padding: 25,
          fontSize: 45, textColor: '#143C34'
        },
        speciesCount: { 
          visible: true, x: 75, y: 240, w: 791, h: 75, 
          bg: '#FFFFFF', borderRadius: 20, padding: 25,
          fontSize: 35, textColor: '#666666'
        },
        brandHeader: {
          visible: true, x: 50, y: 50, w: 841, h: 150,
          bg: '#143C34', borderRadius: 15, padding: 20,
          titleSize: 48, subtitleSize: 24, sloganSize: 36, textColor: '#FFF8DF'
        },
        recordCard: {
          visible: true, x: 75, y: 250, w: 791, h: 400,
          bg: '#FFFFFF', borderRadius: 20, padding: 30,
          speciesSize: 42, infoSize: 28, speciesColor: '#143C34', infoColor: '#666666'
        },
        photoBlock: { visible: true, x: 75, y: 335, w: 791, h: 630, borderRadius: 20 },
        addressBlock: { 
          visible: true, x: 75, y: 985, w: 791, h: 100, 
          bg: '#FFFFFF', borderRadius: 20, padding: 25,
          fontSize: 30, textColor: '#333333'
        },
        coordsBlock: { 
          visible: true, x: 75, y: 1105, w: 791, h: 75, 
          bg: '#FFFFFF', borderRadius: 20, padding: 25,
          fontSize: 25, textColor: '#999999'
        },
        locationBlock: {
          visible: true, x: 75, y: 1200, w: 791, h: 150,
          bg: '#FFFFFF', borderRadius: 20, padding: 25,
          titleSize: 32, addressSize: 28, coordsSize: 22
        },
        qrBlock: { visible: true, x: 75, y: 1360, w: 226, h: 226 },
        userAvatar: { visible: true, x: 351, y: 1385, size: 100 },
        userNickname: { 
          visible: true, x: 476, y: 1410, w: 250, h: 75,
          fontSize: 35, textColor: '#333333', bg: 'rgba(255,255,255,0.9)'
        }
      }
    }
  }
}
</script>
